import { morpheusUrl,  } from "../../config";
import {backUrl} from "../../utils/backURL";
import { fetchWrapper } from "../../utils/fetchWrapper";

export const generateQuickThoughts = async (message, clientId) => {
  const res = await fetchWrapper(
    `${morpheusUrl}/generate_workflow_quick_thoughts`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message,
        client_id: clientId,
      }),
    }
  );
  return res;
};

export const generateWorkflow = async (workflowId, message, quickActions, clientId) => {
  const res = await fetchWrapper(
    `${morpheusUrl}/generate_workflow`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        workflow_id: workflowId,
        message,
        quick_actions: quickActions,
        client_id: clientId,
      }),
    },
    120000
  );
  return res;
};

export const sendWorkflowCreationMessage = async (
  workflowId,
  clientId,
  message
) => {
  const res = await fetchWrapper(`${morpheusUrl}/workflow_run_creation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      workflow_id: workflowId,
      client_id: clientId,
      message,
    }),
  });
  return res;
};

export const getWorkflowVisualization = async (morpheusFlow, messages) => {
  const res = await fetchWrapper(
    `${backUrl}/businessFlows/getFlowVisualization`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        morpheusFlow,
        messages
      })
    }
  );
  return res;
};

export const getWorkflow = async (workflowId, clientId) => {
  const res = await fetchWrapper(`${morpheusUrl}/get_workflow`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      workflow_id: workflowId,
      client_id: clientId,
    }),
  });
  return res;
};
